"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var DisabledBubbleMessage_1 = tslib_1.__importDefault(require("../DisabledBubbleMessage"));
var translations_1 = require("../../utils/translations");
var ConfigSubsection = /** @class */ (function (_super) {
    tslib_1.__extends(ConfigSubsection, _super);
    function ConfigSubsection(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleValue = _this.toggleValue.bind(_this);
        return _this;
    }
    ConfigSubsection.prototype.render = function () {
        var _a = this.props, title = _a.title, intl = _a.intl;
        var className = "configuration-subsection " + this.getTestClassName();
        return (react_1.default.createElement("div", { className: className, "aria-label": "Configuration subsection" },
            react_1.default.createElement("fieldset", null,
                react_1.default.createElement("legend", null,
                    react_1.default.createElement("span", { className: "legend-title" }, translations_1.getTranslation(title, intl)),
                    this.renderToggleSwitch()),
                react_1.default.createElement("div", null, this.props.children))));
    };
    ConfigSubsection.prototype.renderToggleSwitch = function () {
        if (this.props.canBeToggled) {
            var _a = this.props, toggledOn = _a.toggledOn, toggleDisabled = _a.toggleDisabled, showDisabledMessage = _a.showDisabledMessage, title = _a.title, intl = _a.intl, axisType = _a.axisType;
            return (react_1.default.createElement(DisabledBubbleMessage_1.default, { className: "input-checkbox-toggle", showDisabledMessage: showDisabledMessage },
                react_1.default.createElement("label", { className: "s-checkbox-toggle-label" },
                    react_1.default.createElement("input", { "aria-label": axisType + " " + translations_1.getTranslation(title, intl), type: "checkbox", checked: toggledOn, disabled: toggleDisabled, onChange: this.toggleValue, className: "s-checkbox-toggle" }),
                    react_1.default.createElement("span", { className: "input-label-text" }))));
        }
        return null;
    };
    ConfigSubsection.prototype.toggleValue = function (event) {
        var _a = this.props, valuePath = _a.valuePath, properties = _a.properties, pushData = _a.pushData;
        if (valuePath && properties && pushData) {
            var clonedProperties = cloneDeep_1.default(properties);
            set_1.default(clonedProperties, "controls." + valuePath, event.target.checked);
            pushData({ properties: clonedProperties });
        }
    };
    ConfigSubsection.prototype.getTestClassName = function () {
        return "s-configuration-subsection-" + this.props.title.replace(/\./g, "-");
    };
    ConfigSubsection.defaultProps = {
        collapsed: true,
        canBeToggled: false,
        toggleDisabled: false,
        toggledOn: true,
        pushData: noop_1.default,
        showDisabledMessage: false,
    };
    return ConfigSubsection;
}(react_1.default.Component));
exports.default = react_intl_1.injectIntl(ConfigSubsection);
//# sourceMappingURL=ConfigSubsection.js.map